//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';
import 'whatwg-fetch';

const fetchQuery = gql`
  query CommentsForContent($content: UUID!, $site: UUID!, $first: Int, $after: String) {
    commentsForContent(contentUuid: $content, siteUuid: $site, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          uuid
          body
          created
          authorUuid
          author {
            firstName
            lastName
            displayName
            avatar
          }
          comments {
            uuid
            body
            created
            authorUuid
            author {
              firstName
              lastName
              displayName
              avatar
            }
          }
        }
      }
    }
  }
`;

export default {
  props: {
    contentUuid: String,
    contentType: String,
    siteUuid: String,
    endpoint: String,
    auth: String,
    authorUuid: String,
    applicationId: String,
  },
  data() {
    const header = 'Bearer ' + this.$options.auth;
    const appId = this.$options.applicationId;
    const client = new ApolloClient({
      uri: this.$options.endpoint,
      request: function (operation) {
        operation.setContext({
          headers: {
            'X-Portal-Authorization': header,
            'X-Equiem-Application': appId,
          }
        });
      },
    });

    return {
      comments: [],
      contentUuid: this.$options.contentUuid,
      contentType: this.$options.contentType,
      siteUuid: this.$options.siteUuid,
      client,
      authorUuid: this.$options.authorUuid,
      loading: true,
      hasNextPage: false,
      endCursor: null,
      pageSize: 10,
    };
  },
  methods: {
    addComment(event) {
      const comment = event.comment;
      this.comments.unshift({
        uuid: comment.uuid,
        body: comment.body,
        contentUuid: this.$data.contentUuid,
        contentType: this.$data.contentType,
        comments: comment.comments,
        author: comment.author,
        created: comment.created,
      });
    },
    fetchMore() {
      this.client.query({
        query: fetchQuery,
        variables: {
          content: this.$data.contentUuid,
          site: this.$data.siteUuid,
          first: this.$data.pageSize,
          after: this.$data.endCursor,
        }
      }).then(result => {
        this.processResult(result);
      }).catch(error => {
        console.log(error);
      })
    },
    fetchInitial() {
      if (!this.$data.contentUuid || this.$data.siteUuid == null) {
        this.loading = false;
        return;
      }
      this.client.query({
        query: fetchQuery,
        variables: {
          content: this.$data.contentUuid,
          site: this.$data.siteUuid,
          first: this.$data.pageSize,
          after: null,
        }
      }).then(result => {
        this.processResult(result);
      }).catch(error => {
        console.log(error);
      })
    },
    processResult(result) {
      result.data.commentsForContent.edges.map(edge => {
          this.comments.push({
            uuid: edge.node.uuid,
            body: edge.node.body,
            author: edge.node.author,
            contentUuid: this.$options.props.contentUuid.type,
            comments: edge.node.comments,
            created: edge.node.created,
          });
        });
        this.hasNextPage = result.data.commentsForContent.pageInfo.hasNextPage;
        this.endCursor = result.data.commentsForContent.pageInfo.endCursor;
        this.loading = false;
    }
  },
  mounted() {
    this.fetchInitial();
  }
}



// WEBPACK FOOTER //
// ./app/components/organisms/comment-widget/comment-widget.vue